import {ARCHIVE_BUTTON, ARCHIVE_TAX_ID, ARCHIVE_TAX_SLUG} from '../constants'

export default function setTaxonomies(data, filterElement) {
    if (filterElement.hasAttribute(ARCHIVE_BUTTON)) {
        const taxSlug = filterElement.getAttribute(ARCHIVE_TAX_SLUG)
        data.taxonomies[taxSlug] = filterElement.getAttribute(ARCHIVE_TAX_ID)
        data.page_number = 1
    }

    return data
}